export const getOrgId = (state) => state.getIn(['currentUser', 'user', 'orgId'])



// WEBPACK FOOTER //
// ./src/scripts/app/selectors/Org.js